<template>
  <span v-tooltip="tooltipOptions"
        :aria-label="title"
        aria-haspopup="true"
        tabindex="0">
    <i class="icon-info-with-circle"/>
  </span>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    position: {
      type: String,
      required: true,
      default: 'left'
    }
  },
  computed: {
    tooltipOptions: function () {
      return {
        content: this.title,
        classes: `tip-${this.position}`,
        placement: `${this.position}-center`
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tooltip.vue